module.exports = __webpack_public_path__ + "static/media/packettracer.d643a3b0.jpg";